.treeview-item:hover{background-color:#f8f9fa}.treeview-item:hover .checkbox{display:inline-block!important}
/*# sourceMappingURL=dashboard-sources-list.component-IPDYRNYI.css.map */
